<div class="wrapper">


  @if (showProfessionals && showAdmins) {
    <div class="module">
      <h4 class="title tipo-second-color bold">{{"SUPER-ADMIN.LIST-USERS.TITLE-USERS" | translate}} {{companyData?.businessName}}</h4>
      <app-info-company [companyData]="companyData"></app-info-company>
    </div>
  }
  @if (showProfessionals) {
    <div class="module">
      <app-list-professionals></app-list-professionals>
    </div>
  }

  @if (showAdmins) {
    <div class="module">
      <app-list-administratives></app-list-administratives>
    </div>
  }



</div>
